{
    "TelsysList_Column_TelSysID": "EU IA",
    "TelsysList_Column_Description": "Descrição",
    "TelsysList_Column_Trial": "Julgamento",
    "TelsysList_Trial_Yes": "Sim",
    "TelsysList_Trial_No": "Não",
    "TelsysList_Column_PlatformType": "Tipo de plataforma",
    "TelsysList_Column_Licence": "Licença",
    "TelsysList_Column_Partitions": "Partições",
    "TelsysList_Column_Extensions": "Extensões",
    "TelsysList_Column_AcdAgents": "Agentes ACD",
    "TelsysList_Column_AppUsers": "Usuários do aplicativo",
    "TelsysList_Column_Status": "Status",
    "TelsysList_Filter_PlatformType": "Tipo de plataforma",
    "TelsysList_Filter_ReportLicence": "Licença de relatório",
    "TelsysList_Filter_ModuleStatus": "Status do módulo",
    "TelsysList_LicenceFilter_HistoricOnly": "Apenas histórico",
    "TelsysList_LicenceFilter_Standard": "Padrão \/ BLF",
    "TelsysList_LicenceFilter_Enterprise": "Empresa",
    "TelsysList_LicenceFilter_Acd": "ACD",
    "TelsysList_LicenceFilter_None": "Nenhum",
    "TelsysList_LicenceFilter_Mixed": "Misturado",
    "TelsysList_LicenceFilter_Unknown": "Desconhecido",
    "TelsysList_ModuleStatus_mNeg1": "Desconhecido",
    "TelsysList_ModuleStatus_m0": "Acabou de começar ou foi encerrado?",
    "TelsysList_ModuleStatus_m1": "Parou",
    "TelsysList_ModuleStatus_m2": "Começando",
    "TelsysList_ModuleStatus_m3": "Final",
    "TelsysList_ModuleStatus_m4": "Desabilitado",
    "TelsysList_ModuleStatus_m5": "Em execução (inativo)",
    "TelsysList_ModuleStatus_m6": "Executando (sem licença)",
    "TelsysList_ModuleStatus_m7": "Comunicações básicas iniciais",
    "TelsysList_ModuleStatus_m8": "Monitoramento do dispositivo de partida",
    "TelsysList_ModuleStatus_m9": "Interrompendo as comunicações",
    "TelsysList_ModuleStatus_m10": "Correndo",
    "TelsysList_ModuleStatus_m11": "Executando (avisos)",
    "TelsysList_ModuleStatus_m12": "Sincronizando",
    "TelsysList_ModuleStatus_m13": "Sincronizado",
    "TelsysList_ModuleStatus_m14": "Sincronizado (avisos)",
    "TelsysList_ModuleStatus_m15": "Falha na sincronização",
    "TelsysList_ModuleStatus_m16": "Fora de serviço",
    "TelsysList_ModuleStatus_m17": "A comunicação terminou de forma desagradável.",
    "TelsysList_ModuleStatus_m18": "Falha na sincronização",
    "TelsysList_ModuleStatus_m19": "Bots desativados",
    "TelsysList_ModuleStatus_m20": "Bots desativados (avisos)",
    "TelsysList_ModuleStatus_m21": "Inativo (permissão incorreta)",
    "TelsysList_CountLink_PartitionsAria": "Partições abertas filtradas para este servidor de telefonia",
    "TelsysList_CountLink_ExtensionsAria": "Extensões abertas (códigos) filtradas para este servidor de telefonia.",
    "TelsysList_CountLink_AcdAgentsAria": "Agentes ACD abertos filtrados para este servidor de telefonia",
    "TelsysList_CountLink_AppUsersAria": "Usuários de aplicativos abertos filtrados para este servidor de telefonia",
    "NAME": "TelsysListLanguage"
}